import React from 'react'

import Navbar from '../components/navbar/navbar'
import PricingOne from '../components/pricing-one'
import FooterTop from '../components/footer-top'
import Footer from '../components/footer'
import PageTitle from '../components/page-title'

export default function Pricing() {
  return (
    <>
        <Navbar transparent={false}/>

        <PageTitle
          title="Planes y Membresías"
          subtitle="Conoce nuestros planes de afiliación"
        />

        <section>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-7 col-md-10 text-center">
                        <div className="sec-heading center">
                            <h2>See our packages</h2>
                            <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores</p>
                        </div>
                    </div>
                </div>
                <PricingOne/>
            </div>	
        </section>

        <FooterTop bg="theme-bg"/>

        <Footer/>
    </>
  )
}
